<!--<div style="text-align:center; font-size:12px;" *ngIf='rep'>  
            <img *ngIf="rep.PublicImageUrl != '' " height='78' width='75' src="https://extranet.securefreedom.com/Lbri/Personal/PersonalImages/{{rep.PublicImageUrl}}" />
            You are shopping with: <b>{{rep.DisplayName}}</b>
</div>-->
<br />
<span defaultOverlayTarget></span>
<div class="container">
    <div class="create-account">
        <div class="col-md-12 col-sm-12">
            <h5>{{'createAccount.heading.title' | translate}}</h5>
        </div>
        <div class="col-md-12 col-sm-12">
            <h6>{{'createAccount.heading.supportHeading' | translate}}</h6>
        </div>
        <!--<div  *ngIf='customer'><p>Here is the customer id {{addAddress(customer.CustomerDID)}} {{customer.CustomerDID}} </p>
                    </div>-->
        <form [formGroup]="createAccountForm" (ngSubmit)="onSubmit2()" class="row g-3">
            <!-- <div class="col-md-12 col-sm-12"> -->

                <div class="col-md-6 col-sm-6">
                    <label for="firstname">{{'createAccount.fields.labels.firstName' | translate}}</label>
                    <input placeholder="{{'createAccount.fields.placeholderText.firstName' | translate}}"
                        formControlName="custFirst" type="text" class="form-control input-sm" placeholder="">
                    <div *ngIf="createAccountForm.controls['custFirst'].hasError('required') && createAccountForm.controls['custFirst'].touched"
                        class="alert alert-danger">{{'createAccount.fields.validation.errors.firstName' | translate}}
                    </div>
                </div>
                <!--<div *ngIf='customer  && customer.length'>-->
                <!--<div *ngIf='customer'><p>Here is the customer id {{customer.CustomerDID}} </p>
                    </div>-->
                <!--</div>-->


                <div class=" col-md-6 col-sm-6">
                    <label for="lastname">{{'createAccount.fields.labels.lastName' | translate}}</label>
                    <input placeholder="{{'createAccount.fields.placeholderText.lastName' | translate}}"
                        formControlName="custLast" type="text" class="form-control input-sm" placeholder="">
                    <div *ngIf="createAccountForm.controls['custLast'].hasError('required') && createAccountForm.controls['custLast'].touched"
                        class="alert alert-danger">{{'createAccount.fields.validation.errors.lastName' | translate}}
                    </div>

                </div>
                <div class="col-md-6 col-sm-6">
                    <label for="email">{{'createAccount.fields.labels.email' | translate}}</label>
                    <input placeholder="{{'createAccount.fields.placeholderText.email' | translate}}"
                        (blur)="checkEmailAdd()" formControlName="custEmail" type="email" class="form-control input-sm"
                        placeholder="">
                    <div *ngIf="emailGood == false && createAccountForm.controls['custEmail'].touched"
                        class="alert alert-danger">{{errorMessage}}</div>
                    <div *ngIf="dupEmail == false && emailGood == true" class="alert alert-danger">{{errorMessage |
                        translate}}
                    </div>

                    <!--<div *ngIf="createAccountForm.controls['custEmail'].hasError('required') && createAccountForm.controls['custEmail'].touched" class="alert alert-danger">Email address is required.</div>-->

                </div>
                <a id="address"></a>
                <div class="col-md-6 col-sm-6">
                    <label for="address">{{'createAccount.fields.labels.street1' | translate}}</label>
                    <input placeholder="{{'createAccount.fields.placeholderText.street1' | translate}}" type="text"
                        formControlName="custStreet" class="form-control input-sm">
                    <div *ngIf="createAccountForm.controls['custStreet'].hasError('required') && createAccountForm.controls['custStreet'].touched"
                        class="alert alert-danger">{{'createAccount.fields.validation.errors.street1' | translate}}
                    </div>

                </div>
                <div class="col-md-6 col-sm-6">
                    <label for="pincode">{{'createAccount.fields.labels.zip' | translate}}</label>
                    <input placeholder="{{'createAccount.fields.placeholderText.zip' | translate}}"
                        (blur)="getZipInfo()" formControlName="custZip" type="text" class="form-control input-sm"
                        placeholder="">
                    <div *ngIf="zipGood == false && createAccountForm.controls['custZip'].touched"
                        class="alert alert-danger">{{zipErrorMessage | translate}}</div>

                    <!--<div *ngIf="createAccountForm.controls['custZip'].hasError('required') && createAccountForm.controls['custZip'].touched" class="alert alert-danger">Zipcode is required.</div>-->

                </div>
                <div class="col-md-6 col-sm-6">
                    <label for="city">{{'createAccount.fields.labels.city' | translate}}</label>
                    <select formControlName="custCity" class="form-select form-select-sm">
                        <option *ngFor="let city of cities">{{city}}</option>
                    </select>
                    <!--<input formControlName="custCity" type="text" class="form-control input-sm" placeholder="">-->
                    <div *ngIf="createAccountForm.controls['custCity'].hasError('required') && createAccountForm.controls['custCity'].touched"
                        class="alert alert-danger">{{'createAccount.fields.validation.errors.city' | translate}}</div>

                </div>

                <div class="col-md-6 col-sm-6">
                    <label for="state">{{'createAccount.fields.labels.state' | translate}}</label>
                    <select formControlName="custState" class="form-select form-select-sm">
                        <option *ngFor="let state of states">{{state}}</option>
                    </select>
                    <!--<input formControlName="custState" type="text" class="form-control input-sm"  placeholder="">-->
                    <div *ngIf="createAccountForm.controls['custState'].hasError('required') && createAccountForm.controls['custState'].touched"
                        class="alert alert-danger">{{'createAccount.fields.validation.errors.state' | translate}}</div>

                </div>

                <div class="col-md-6 col-sm-6">
                    <label for="type">{{'createAccount.fields.labels.county' | translate}}</label>
                    <select formControlName="custCounty" class="form-select form-select-sm">
                        <option *ngFor="let county of counties">{{county}}</option>
                    </select>
                    <div *ngIf="createAccountForm.controls['custCounty'].hasError('required') && createAccountForm.controls['custCounty'].touched"
                        class="alert alert-danger">{{'createAccount.fields.validation.errors.county' | translate}}</div>
                </div>
                <div class="col-md-6 col-sm-6">
                    <label for="country">{{'createAccount.fields.labels.phone' | translate}}</label>
                    <input placeholder="{{'createAccount.fields.placeholderText.phone' | translate}}"
                        formControlName="custPhone" type="text" class="form-control input-sm" placeholder=""
                        mask="000-000-0000">
                    <div *ngIf="createAccountForm.controls['custPhone'].hasError('required') && createAccountForm.controls['custPhone'].touched"
                        class="alert alert-danger">{{'createAccount.fields.validation.errors.phone' | translate}}</div>

                </div>
                <div class="col-md-6 col-sm-6">
                    <label for="pincode">{{'createAccount.fields.labels.password' | translate}}</label>
                    <input formControlName="custPass" type="password" class="form-control input-sm" placeholder="">
                    <div *ngIf="createAccountForm.controls['custPass'].hasError('required') && createAccountForm.controls['custPass'].touched"
                        class="alert alert-danger">{{'createAccount.fields.validation.errors.password' | translate}}
                    </div>
                    <div *ngIf="createAccountForm.controls['custPass'].hasError('minlength') && createAccountForm.controls['custPass'].touched"
                        class="alert alert-danger">{{'createAccount.fields.validation.errors.passwords.atLeast5' |
                        translate}}</div>
                    <div *ngIf="createAccountForm.controls['custPass'].hasError('maxlength') && createAccountForm.controls['custPass'].touched"
                        class="alert alert-danger">{{'createAccount.fields.validation.errors.passwords.lessThan40' |
                        translate}}</div>
                </div>

                <div class="col-md-6 col-sm-6">
                    <label for="pincode">{{'createAccount.fields.labels.confirmPassword' | translate}}</label>
                    <input formControlName="custPass2" type="password" class="form-control input-sm" placeholder="">
                    <div *ngIf="createAccountForm.controls['custPass2'].hasError('required') && createAccountForm.controls['custPass2'].touched"
                        class="alert alert-danger">{{'createAccount.fields.validation.errors.confirmPassword' |
                        translate}}</div>
                    <div class="alert alert-danger"
                        *ngIf="createAccountForm?.get('custPass2')?.errors?.['MatchPassword'] && createAccountForm.controls['custPass2'].touched">
                        {{'createAccount.fields.validation.errors.passwordNoMatch' | translate}}</div>

                </div>

                <div class="col-md-6 col-sm-6">
                    <label for="type">{{'createAccount.fields.labels.language' | translate}}</label>



                    <select #selectDropDown formControlName="custLocale" (change)="setNewCustLang(selectDropDown.value)"
                        class="form-select form-select-sm">
                        <option *ngFor="let language of languages" [value]="language.code"
                            [selected]="language.code === translate.currentLang">
                            {{ language.name }}
                        </option>
                    </select>
                    <div *ngIf="createAccountForm.controls['custHow'].hasError('required') && createAccountForm.controls['custHow'].touched"
                        class="alert alert-danger">{{'createAccount.fields.validation.errors.howDidYouHearReq' |
                        translate}}</div>
                </div>


                <div class="col-md-6 col-sm-6">
                    <label for="type">{{'createAccount.fields.labels.howDidYouHear' | translate}}</label>
                    <select #selectDropDown formControlName="custHow" (change)="onSelectionChange(selectDropDown.value)"
                        class="form-select form-select-sm">
                        <option *ngFor="let type of displayRefMarketTypes;" [value]="type.ID">{{type.Description}}
                        </option>

                        <!----  <option [value]="1" [selected]="true">Consultant</option>
                        <option [value]="2" >Friends/Family</option>
                        <option [value]="5">Facebook</option>
                        <option [value]="7">Instagram</option>
                        <option [value]="8">Influencers/Blog</option>-->
                    </select>
                    <div *ngIf="createAccountForm.controls['custHow'].hasError('required') && createAccountForm.controls['custHow'].touched"
                        class="alert alert-danger">{{'createAccount.fields.validation.errors.howDidYouHearReq' |
                        translate}}</div>
                </div>
                <!---- <input formControlName="custMessage" type="text" class="form-control input-sm" placeholder="Enter Consultants first and last name, tell us more*"> -->
                <!-- <ng-container *ngFor="let type of displayRefMarketTypes" >             -->
                <!-- <div *ngIf="createAccountForm.controls['custHow'].value === type.ID" class="form-group col-md-6 col-sm-6"> -->
                <div>
                    <label for="more">{{'createAccount.fields.labels.tellUsMore' | translate}}</label>
                    <input formControlName="custMessage" type="text" class="form-control input-sm"
                        placeholder="{{this.custPlaceHolder}}">
                    <div *ngIf="createAccountForm.controls['custMessage'].hasError('required') && createAccountForm.controls['custMessage'].touched"
                        class="alert alert-danger">{{'createAccount.fields.validation.errors.tellUsMoreReq' |
                        translate}}</div>
                </div>
                <!-- </ng-container> -->
                <!---- <div *ngIf="createAccountForm.controls['custHow'].value == 2" class="form-group col-md-6 col-sm-6">
                <label for="more">Tell us more*</label>
                <input formControlName="custMessage" type="text" class="form-control input-sm" placeholder="Enter their first and last name, tell us more*">
                <div *ngIf="createAccountForm.controls['custMessage'].hasError('required') && createAccountForm.controls['custMessage'].touched" class="alert alert-danger">A response is required.</div>

            </div>
            <div *ngIf="createAccountForm.controls['custHow'].value == 5 || createAccountForm.controls['custHow'].value == 7" class="form-group col-md-6 col-sm-6">
                <label for="more">Tell us more*</label>
                <input formControlName="custMessage" type="text" class="form-control input-sm" placeholder="Tell us more*">
                <div *ngIf="createAccountForm.controls['custMessage'].hasError('required') && createAccountForm.controls['custMessage'].touched" class="alert alert-danger">A response is required.</div>

            </div>

            <div *ngIf="createAccountForm.controls['custHow'].value == 8" class="form-group col-md-6 col-sm-6">
                <label for="more">Tell us more*</label>
                <input formControlName="custMessage" type="text" class="form-control input-sm" placeholder="Enter name, tell us more*">
                <div *ngIf="createAccountForm.controls['custMessage'].hasError('required') && createAccountForm.controls['custMessage'].touched" class="alert alert-danger">A response is required.</div>

            </div>           
        -->
                <!--<div class='row'>
                    <div class='col-md-2'>First Name:</div>
                    <div class='col-md-4'>
                        <input formControlName="custFirst" placeholder="First Name" type='text' />
                    </div>
            </div>-->
                <!--<div class='row'>
                    <div class='col-md-2'>Last Name:</div>
                    <div class='col-md-4'>
                        <input formControlName="custLast" placeholder="Last Name" type='text' />
                    </div>
            </div>-->
                <!--<div class='row'>
                    <div class='col-md-2'>Email Address:</div>
                    <div class='col-md-4'>
                        <input formControlName="custEmail" placeholder="Email Address" type='email' />
                    </div>
            </div>-->
                <!--<div class='row'>
                    <div class='col-md-2'>Password:</div>
                    <div class='col-md-4'>
                        <input formControlName="custPass" placeholder="Password" type='password' />
                    </div>
            </div>
            <div class='row'>
                    <div class='col-md-2'>Confirm Password:</div>
                    <div class='col-md-4'>
                        <input formControlName="custPass2" placeholder="Confirm Password" type='password' />
                    </div>
            </div>-->

            <!-- </div> -->
            <div class="col-md-12 col-sm-12 extra-bottom-spacing">
                <button name="submitButton" #submitButton [disabled]="!createAccountForm.valid" type="submit"
                    class='btn btn-primary btn-main btn-block'>{{'createAccount.buttons.createAccountSubmit' |
                    translate}}</button>
            </div>
        </form>
        <ng-template #contentStuff let-modal>
            <div class="modal-content validation-modal">
                <div class="modal-header" *ngIf='addresses === null'>
                    <h3 class="modal-title"><i class="fa fa-map-marker" aria-hidden="true"></i>
                        &nbsp;{{'validateAddress.modal.errors.noMatchFound' | translate}}
                    </h3>
                </div>
                <div class="modal-header" *ngIf='addresses'>
                    <h3 class="modal-title"><i class="fa fa-map-marker" aria-hidden="true"></i>
                        &nbsp;{{'validateAddress.modal.errors.matchFound' | translate}}
                    </h3>
                </div>
            </div>
            <div class="modal-body">
                <div *ngIf='addresses === null'>
                    <p>{{'validateAddress.modal.paragraph.notRecognizedByUSPS' | translate}}</p>
                    <p>{{'validateAddress.modal.paragraph.missingOrInvalidInfo' | translate}}</p>
                    <ul>
                        <li>{{'validateAddress.modal.items.streetName' | translate}}</li>
                        <li>{{'validateAddress.modal.items.streetNumber' | translate}}</li>
                        <li>{{'validateAddress.modal.items.aptOrHouseNumber' | translate}}</li>
                    </ul>
                </div>
                <validadd> </validadd>
            </div>
            <div class="modal-footer">
                <button name="editButton" #editButton class="btn btn-primary btn-main btn-block"
                    (click)="editAddress()">{{'validateAddress.modal.buttons.editAddress' | translate}}</button>
            </div>
        </ng-template>
    </div>
    <ngx-spinner bdColor="rgba(0, 0, 0, 0.8)" size="medium" color="#fff" type="ball-spin-clockwise" [fullScreen]="true">
        <p style="color: white"> {{'createAccount.spinner.creatingAccount' | translate}}</p>
    </ngx-spinner>